import { api } from 'api/api'
import { z } from 'zod'

const companyPositionTemplateBlockSchema = z.object({
  positionTemplateId: z.number(),
  blocked: z.boolean(),
})

export type CompanyPositionTemplateBlock = z.infer<
  typeof companyPositionTemplateBlockSchema
>

const mutateCompanyPositionTemplateBlockRequestSchema = z.object({
  companyId: z.number(),
  workerId: z.number(),
  reason: z.string().min(25, {
    message: 'Reason must be at least 25 characters',
  }),
  positionTemplateBlocks: z.array(companyPositionTemplateBlockSchema),
})
export type MutateCompanyPositionTemplateBlockRequest = z.infer<
  typeof mutateCompanyPositionTemplateBlockRequestSchema
>

const mutateCompanyPositionTemplateBlockResponseSchema = z.object({
  companyPositionTemplateBlockIds: z.array(z.number()),
})
type MutateCompanyPositionTemplateBlockResponse = z.infer<
  typeof mutateCompanyPositionTemplateBlockResponseSchema
>

export async function mutateCompanyPositionTemplateBlock({
  companyId,
  workerId,
  reason,
  positionTemplateBlocks,
}: MutateCompanyPositionTemplateBlockRequest) {
  return api.post<MutateCompanyPositionTemplateBlockResponse>(
    `/company/${companyId}/worker/${workerId}/company_position_template_block`,
    {
      reason: reason,
      positionTemplateBlocks: positionTemplateBlocks,
    }
  )
}
